import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import AppRoutes from './routes/AppRoutes';
import { Toaster } from 'sonner';
import ReportingPage from './pages/ReportingPage';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Toaster 
        position="top-right"
        expand={false}
        richColors
        closeButton
      />
      <Router>
        <Layout>
          <AppRoutes />
        </Layout>
      </Router>
    </AuthProvider>
  );
};

export default App;